function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Render a set of highlights. See HighlightRenderer for more details about how
 * each highlight is rendered.
 *
 * This component manages the state of the "Remove highlight" tooltip. To
 * determine the currently-hovered highlight, it calls the `isHovered` method
 * on each HighlightRenderer.
 */
var React = require("react");

var HighlightRenderer = require("./highlight-renderer.jsx");
var HighlightTooltip = require("./highlight-tooltip.jsx");

/* global i18n */

var babelPluginFlowReactPropTypes_proptype_ZIndexes = require("./types.js").babelPluginFlowReactPropTypes_proptype_ZIndexes || require("react").PropTypes.any;

var babelPluginFlowReactPropTypes_proptype_Position = require("./types.js").babelPluginFlowReactPropTypes_proptype_Position || require("react").PropTypes.any;

var babelPluginFlowReactPropTypes_proptype_DOMHighlightSet = require("./types.js").babelPluginFlowReactPropTypes_proptype_DOMHighlightSet || require("react").PropTypes.any;

var HighlightSetRenderer = function (_React$PureComponent) {
    _inherits(HighlightSetRenderer, _React$PureComponent);

    function HighlightSetRenderer() {
        var _temp, _this, _ret;

        _classCallCheck(this, HighlightSetRenderer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            mouseClientPosition: null,
            hoveringTooltipFor: null

            // eslint-disable-next-line react/sort-comp
        }, _this._highlightRenderers = {}, _this._handleMouseMove = function (e) {
            _this.setState({
                mouseClientPosition: {
                    left: e.clientX,
                    top: e.clientY
                }
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    HighlightSetRenderer.prototype.componentDidMount = function componentDidMount() {
        this._updateEditListeners(false, this.props.editable);
    };

    HighlightSetRenderer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this._updateEditListeners(this.props.editable, nextProps.editable);

        // If we were previously hovering over the tooltip for a highlight that
        // has since been removed, reset the hover state accordingly.
        if (typeof this.state.hoveringTooltipFor === "string" && !(this.state.hoveringTooltipFor in nextProps.highlights)) {
            this.setState({ hoveringTooltipFor: null });
        }
    };

    HighlightSetRenderer.prototype.componentWillUnmount = function componentWillUnmount() {
        this._updateEditListeners(this.props.editable, false);
    };

    /**
     * Given whether we were previously listening to mousemove events, and
     * whether we will now listen to mousemove events, add or remove the
     * listener accordingly.
     */


    HighlightSetRenderer.prototype._updateEditListeners = function _updateEditListeners(wasListening, willListen) {
        if (!wasListening && willListen) {
            window.addEventListener("mousemove", this._handleMouseMove);
        } else if (wasListening && !willListen) {
            window.removeEventListener("mousemove", this._handleMouseMove);

            // Additionally, reset the mouse position. Our child components
            // won't be checking `mouseClientPosition` when we're not
            // listening, anyway, but this guards against errors where we
            // re-enter listening mode and have stale coordinates stored in
            // state.
            this.setState({
                mouseClientPosition: null
            });
        }
    };

    HighlightSetRenderer.prototype._getHoveredHighlightKey = function _getHoveredHighlightKey() {
        var _this2 = this;

        // If we're hovering over the tooltip, the hovered highlight is the
        // highlight that the tooltip is pointing to.
        var hoveringTooltipFor = this.state.hoveringTooltipFor;

        if (typeof hoveringTooltipFor === "string") {
            return hoveringTooltipFor;
        }

        // Otherwise, check each highlight renderer to see whether the current
        // mouse position intersects any of the highlight rectangles.
        var highlightKeys = Object.keys(this.props.highlights);
        return highlightKeys.find(function (key) {
            var highlightRenderer = _this2._highlightRenderers[key];
            return highlightRenderer && highlightRenderer.isHovered(_this2.state.mouseClientPosition);
        });
    };

    HighlightSetRenderer.prototype._renderTooltip = function _renderTooltip() {
        var _this3 = this;

        var hoveredHighlightKey = this._getHoveredHighlightKey();
        if (typeof hoveredHighlightKey !== "string") {
            return null;
        }

        var hoveredHighlight = this.props.highlights[hoveredHighlightKey];

        return React.createElement(HighlightTooltip, {
            label: i18n._("Remove highlight"),

            focusNode: hoveredHighlight.domRange.endContainer,
            focusOffset: hoveredHighlight.domRange.endOffset,
            offsetParent: this.props.offsetParent,
            zIndex: this.props.zIndexes.aboveContent,

            onClick: function onClick() {
                return _this3.props.onRemoveHighlight(hoveredHighlightKey);
            },
            onMouseEnter: function onMouseEnter() {
                return _this3.setState({ hoveringTooltipFor: hoveredHighlightKey });
            },
            onMouseLeave: function onMouseLeave() {
                return _this3.setState({ hoveringTooltipFor: null });
            }
        });
    };

    HighlightSetRenderer.prototype.render = function render() {
        var _this4 = this;

        return React.createElement(
            "div",
            null,
            Object.keys(this.props.highlights).map(function (key) {
                return React.createElement(HighlightRenderer, {
                    ref: function ref(r) {
                        if (r) {
                            _this4._highlightRenderers[key] = r;
                        } else {
                            delete _this4._highlightRenderers[key];
                        }
                    },
                    editable: _this4.props.editable,
                    key: key,
                    highlight: _this4.props.highlights[key],
                    highlightKey: key,
                    mouseClientPosition: _this4.state.mouseClientPosition,
                    offsetParent: _this4.props.offsetParent,
                    onRemoveHighlight: _this4.props.onRemoveHighlight,
                    zIndexes: _this4.props.zIndexes
                });
            }),
            this.props.editable && this._renderTooltip()
        );
    };

    return HighlightSetRenderer;
}(React.PureComponent);

HighlightSetRenderer.propTypes = {
    editable: require("react").PropTypes.bool.isRequired,
    highlights: babelPluginFlowReactPropTypes_proptype_DOMHighlightSet,
    offsetParent: require("react").PropTypes.any.isRequired,
    onRemoveHighlight: require("react").PropTypes.func.isRequired,
    zIndexes: babelPluginFlowReactPropTypes_proptype_ZIndexes
};


module.exports = HighlightSetRenderer;


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/highlighting/ui/highlight-set-renderer.jsx
 ** module id = 347
 ** module chunks = 0 1
 **/